export default __webpack_public_path__ + "static/media/26.19954875.jpg";